import { dataTrigger as attr, track as send } from "@bk/app-events";

/**
 * Справочник триггеров приложения: имя → где элемент и что делает.
 * Имя — `bkn.экран.элемент`; не меняется при переименовании или переносе кнопки.
 * Новая кнопка — новая запись здесь и `data-trigger` на элементе.
 */
export const TRIGGERS = {
  "bkn.app.open": "Открытие приложения",

  "bkn.main.buy":
    "Главный экран без подписки, кнопка «Купить подписку 199₽/месяц»",
  "bkn.main.install":
    "Главный экран с подпиской, кнопка «Установить» — переход к установке VPN-клиента",
  "bkn.main.change_card":
    "Главный экран с подпиской, «Изменить» у карты — переход к способам оплаты",
  "bkn.main.support":
    "Главный экран с подпиской, кнопка «Поддержка в Telegram»",
  "bkn.main.cancel_subscription":
    "Главный экран, ссылка «Отменить подписку» — открывает подтверждение",
  "bkn.main.cancel_confirm":
    "Подтверждение отмены подписки, кнопка «Отменить» — автопродление выключается",
  "bkn.main.cancel_keep": "Подтверждение отмены подписки, кнопка «Не отменять»",
  "bkn.main.resume_subscription":
    "Главный экран с отменённой подпиской, ссылка «Возобновить подписку»",
  "bkn.main.promo_open":
    "Главный экран, ссылка «Есть промокод?» — открывает поле (видно, если промокоды включены)",
  "bkn.main.promo_submit": "Поле промокода, кнопка «Активировать»",
  "bkn.main.promo_success": "Промокод активирован; не нажатие",

  "bkn.app_login.show":
    "Показ экрана подтверждения входа в БКоннект на компьютере (ссылка startapp=applogin); не нажатие",
  "bkn.app_login.confirm":
    "Подтверждение входа в БКоннект, кнопка «Подтвердить вход»",
  "bkn.app_login.reject": "Подтверждение входа в БКоннект, кнопка «Это не я»",
  "bkn.app_login.enter_code":
    "Подтверждение входа в БКоннект, ввод кода вручную, кнопка «Продолжить»",
  "bkn.app_login.retry":
    "Подтверждение входа в БКоннект после ошибки, кнопка «Ввести код вручную»",
  "bkn.app_login.close":
    "Вход в БКоннект подтверждён, кнопка «Готово» — закрывает мини-апп",
  "bkn.app_login.home":
    "Подтверждение входа в БКоннект, кнопка «На главную»",

  "bkn.email_modal.submit":
    "Окно ввода почты перед оплатой или привязкой карты, кнопка «Продолжить к оплате»",
  "bkn.email_modal.close": "Окно ввода почты перед оплатой, крестик",

  "bkn.success_modal.show":
    "Показ окна «Подписка оформлена» после возврата с оплаты; не нажатие",
  "bkn.success_modal.ok": "Окно «Подписка оформлена», кнопка «Отлично!»",
  "bkn.success_modal.close": "Окно «Подписка оформлена», крестик",

  "bkn.payment_methods.back":
    "Экран способов оплаты, кнопка «Назад» на главный экран",
  "bkn.payment_methods.select_card":
    "Экран способов оплаты, выбор карты для автопродления",
  "bkn.payment_methods.add_card":
    "Экран способов оплаты, кнопка «Добавить карту»",
  "bkn.payment_methods.delete_card":
    "Экран способов оплаты, корзина у карты — открывает подтверждение",
  "bkn.payment_methods.delete_confirm":
    "Подтверждение удаления карты, кнопка «Удалить»",
  "bkn.payment_methods.delete_cancel":
    "Подтверждение удаления карты, кнопка «Отмена»",

  "bkn.install.download":
    "Экран установки, шаг 1, кнопка «Скачать для …»; платформа — в контексте `os`",
  "bkn.install.add_config":
    "Экран установки, шаг 2, кнопка «Добавить конфиг» — открывает VPN-клиент",
  "bkn.install.done_home": "Экран установки, шаг 3, кнопка «На главную»",
  "bkn.install.bkvpn_download":
    "Экран установки на Windows, шаг 1, кнопка «Скачать для Windows» — установщик БКоннект (x64)",
  "bkn.install.bkvpn_download_arm":
    "Экран установки на Windows, шаг 1, ссылка «Скачать версию для ARM» — установщик БКоннект (ARM64)",
  "bkn.install.bkvpn_add":
    "Экран установки на Windows и Android, шаг 2, кнопка «Добавить в приложение» — открывает приложение со ссылкой входа",
  "bkn.install.bkvpn_download_android":
    "Экран установки на Android, шаг 1, кнопка «Скачать для Android» — APK приложения БКоннект",
  "bkn.install.other_devices":
    "Экран установки, шаг 1, кнопка «Другие устройства» — открывает инструкции",
  "bkn.install.step_prev": "Экран установки, кнопка «Назад» между шагами",
  "bkn.install.step_next": "Экран установки, кнопка «Далее» между шагами",
  "bkn.install.step_dot": "Экран установки, точки-переключатели шагов вверху",
  "bkn.install.close": "Экран установки, последний шаг, кнопка «Закрыть»",

  "bkn.instructions.back": "Экран инструкций по устройствам, кнопка «Назад»",
  "bkn.instructions.guide_ios": "Экран инструкций, кнопка «iOS»",
  "bkn.instructions.guide_android": "Экран инструкций, кнопка «Android»",
  "bkn.instructions.guide_windows": "Экран инструкций, кнопка «Windows»",
  "bkn.instructions.guide_macos": "Экран инструкций, кнопка «macOS»",

  "bkn.auth.login": "Вход по почте (веб), кнопка «Войти»",
  "bkn.auth.register":
    "Регистрация по почте (веб), кнопка «Зарегистрироваться»",
  "bkn.auth.resend_email":
    "Регистрация по почте (веб), кнопка «Отправить письмо повторно»",
  "bkn.auth.to_register":
    "Вход по почте (веб), ссылка «Нет аккаунта? Регистрация»",
  "bkn.auth.to_login":
    "Регистрация по почте (веб), ссылка «Уже есть аккаунт? Войти»",
  "bkn.auth.go_login":
    "Регистрация по почте (веб), кнопка «Перейти ко входу» после отправки письма",
  "bkn.web_login.start": "Вход на сайте (веб), кнопка «Войти через Telegram»",
  "bkn.web_login.open_telegram": "Вход на сайте через Telegram, кнопка «Открыть Telegram» (ссылка в мини-апп с кодом)",
  "bkn.web_login.retry": "Вход на сайте через Telegram, код устарел, кнопка «Получить новый код»",
  "bkn.web_login.open_browser":
    "Вход на сайте через Telegram, после «Открыть Telegram» — ссылка «откройте ссылку в браузере» (t.me)",
  "bkn.auth.code_submit": "Экран «Проверьте почту», кнопка «Войти» с кодом из письма",
  "bkn.auth.code_resend": "Экран «Проверьте почту», кнопка «Отправить ещё раз»",
  "bkn.auth.code_change_email": "Экран «Проверьте почту», ссылка «Изменить почту»",
  "bkn.auth.login_by_code":
    "Вход по почте (веб), ссылка «Забыли пароль? Войти по коду из письма»",
  "bkn.auth.login_by_code_send": "Вход по коду из письма, кнопка «Прислать код»",
} as const;

export type Trigger = keyof typeof TRIGGERS;

/** Атрибут `data-trigger` для элемента: имя вне справочника не скомпилируется. */
export const dataTrigger = (name: Trigger) => attr(name);

/** Триггер вручную — для событий, которые не являются нажатием. */
export const track = (name: Trigger) => send(name);
